import {certificateElementType} from "~/enums/certificateElementType";
import DynamicModeCertificateElement from "./dynamicCertificateElement";
import AdaptiveLayoutSection from "./adaptiveLayoutSection";
import {HorizontalAlignment} from "~/enums/certificates/alignment";


export default class DividerCertificateElement extends DynamicModeCertificateElement {
  type: certificateElementType = certificateElementType.Divider
  horizontal_alignment: number;

  line_style: number;
  line_thickness: number;

  padding_top: number;
  padding_bottom: number;
  padding_left: number;
  padding_right: number;

  parent: AdaptiveLayoutSection;

  get dividerWidth(): number{
    return this.parent.dimensions.width - this.parent.totalHorizontalMargin
  }

  get maxWidth(): number{
    return this.parent.dimensions.width - this.parent.totalHorizontalMargin
  }

  get x(): number {
    switch (this.horizontal_alignment) {
      case HorizontalAlignment.Left:
        return 0;
      case HorizontalAlignment.Middle:
        return (this.maxWidth - this.width) / 2;
      case HorizontalAlignment.Right:
        return this.maxWidth - this.width;
    }
  }

}